export var PositionEnum;

!function(PositionEnum) {
    PositionEnum.middle = "middle", PositionEnum.start = "start", PositionEnum.end = "end", 
    PositionEnum.bothEnd = "bothEnd";
}(PositionEnum || (PositionEnum = {}));

export var minMaxPositionEnum;

!function(minMaxPositionEnum) {
    minMaxPositionEnum.middle = "middle", minMaxPositionEnum.start = "start", minMaxPositionEnum.end = "end";
}(minMaxPositionEnum || (minMaxPositionEnum = {}));
//# sourceMappingURL=interface.js.map
